import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\">\n<path d=\"M41.4371 12H37.9215C37.6824 12 37.4574 12.1172 37.3168 12.3094L23.9996 30.6656L10.6824 12.3094C10.5418 12.1172 10.3168 12 10.0777 12H6.56212C6.25743 12 6.0793 12.3469 6.25743 12.5953L22.7856 35.3812C23.3856 36.2062 24.6137 36.2062 25.209 35.3812L41.7371 12.5953C41.9199 12.3469 41.7418 12 41.4371 12V12Z\" fill=\"#1890ff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol